module.exports = __webpack_public_path__ + "img/tracks.2f52fd32.svg";